// Libraries
import React, { Component } from "react";

// Functions
import { getFileType } from "../../../utils/scripts/type";

class Thumbnail extends Component {
  state = {
    src: "",
    alt: "",
    type: "",
  };

  // Retrive the Data from props
  async componentDidMount() {
    const { filename, path, alt, id } = this.props;

    const src = this.getSource(filename, path, id);
    const type = await getFileType(src);

    this.setState({ src: src, alt: alt, id: id, type: type });
  }

  getSource = (filename, path, id) => {
    const baseUrl = process.env.REACT_APP_API_URL;
    const regex = /(http(s?)):\/\//i;

    let src = "";
    if (!filename) {
      src = `${process.env.PUBLIC_URL}/placeholder.png`;
    } else if (filename.match(regex)) {
      src = filename;
    } else {
      src = `${baseUrl}/${path}/${id}/${filename}`;
    }

    return src;
  };

  render() {
    const { src, alt, id, type } = this.state;

    return (
      <div className="row align-items-center ">
        {type === "audio" ? (
          <audio
            src={src}
            id={id}
            alt={alt}
            controls={true}
            style={{ width: "250px" }}
          />
        ) : (
          <div className="frame">
            <span className="helper"></span>
            {type === "image" && <img src={src} alt={alt} key={id} />}
            {type === "video" && (
              <video src={src} id={id} alt={alt} controls={true} />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Thumbnail;
